import { CoreClient } from 'common'
import auth0Plugin from '@/setups/authSetup'

export const getToken = async (attempt = 0): Promise<string | undefined> => {
  if (attempt > 5) {
    console.error('Reached the 5th attempt when trying to get a token')
    return undefined
  }
  return new Promise((resolve) => {
    auth0Plugin
      .getAccessTokenSilently()
      .then((token) => {
        resolve(token)
      })
      .catch(() => {
        return getToken(attempt + 1)
      })
  })
}

export const coreClient = async () => {
  return new CoreClient({
    BASE: import.meta.env.VITE_API_URL,
    TOKEN: await getToken()
  })
}
